import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from 'reducers';

const persistConfig: any = {
  key: process.env.REACT_APP_NAME,
  storage,
  blacklist: [],
};

export type ApacuanaContextType = {
  sdk: any; // o el tipo real del SDK
  isInitialized: boolean;
  error: Error | null;
  updateSdkConfig: (newCustomerId: string) => Promise<void>;
  initApacuanaSdk: (customerId?: string) => void;
  user: any; // o el tipo de tu objeto user
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(persistedReducer);
const persistor = persistStore(store);

export { store, persistor };
